import type { WebObservability } from "@infinitaslearning/observability-web";
import { createContext, type ReactNode, useContext } from "react";

const ObservabilityContext = createContext<WebObservability | null>(null);

interface Props {
  children: ReactNode;
  apm: WebObservability;
}

export function ObservabilityProvider({ children, apm }: Props) {
  return <ObservabilityContext.Provider value={apm}>{children}</ObservabilityContext.Provider>;
}

export function useObservability() {
  const context = useContext(ObservabilityContext);
  if (!context) {
    throw new Error("useObservability must be used within ObservabilityProvider");
  }
  return context;
}
